import {
  VideoEventHandlers,
  VideoExternalPlayState,
  VideoOverlay,
} from '@mc/video'

import SubscribeVideoScreen from 'components/VideoModal/SubscribeVideoScreen'
import { VideoPlayer as VideoPlayerComponent } from 'components/VideoPlayer'

import { useAboutSectionVideo } from '../AboutSectionVideoContext'

export const VideoPlayer = () => {
  const {
    videoId,
    mediaUuid,
    isPlaying,
    hasPlayed,
    handleVideoPlay,
    handleVideoPause,
    isSample,
    trackingParams,
  } = useAboutSectionVideo()

  const renderPauseScreen = () => <SubscribeVideoScreen isSample={isSample} />

  return (
    <div
      className={`mc-corners--lg mc-overflow--hidden ${
        hasPlayed ? '' : 'd-none'
      }`}
    >
      {(videoId || mediaUuid) && (
        <VideoPlayerComponent
          {...trackingParams}
          videoId={videoId}
          mediaUuid={mediaUuid}
          playsInline
        >
          <VideoEventHandlers
            onPlay={handleVideoPlay}
            onPause={handleVideoPause}
          />
          <VideoExternalPlayState playing={isPlaying} />
          <VideoOverlay state={['paused', 'ended']} fade style={{ zIndex: 1 }}>
            {renderPauseScreen()}
          </VideoOverlay>
        </VideoPlayerComponent>
      )}
    </div>
  )
}
